<template>
  <div>
    <v-row justify="center">
      <div class="title mb-2 mt-3">
        <h1 :class="{ 'noSubheading': !subheading }">{{ title }}</h1>
        <h2 v-if="subheading">{{ subheading }}</h2>
      </div>
    </v-row>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  name: "PageHeading",
  props: {
    title: {
      required: true,
      type: String
    },
    subheading: {
      required: false,
      type: String,
      default: ""
    }
  }
}
</script>
<style lang="scss">
.title {
  h1, h2 {
    font-weight: normal;
    color: #404040;
    text-transform: uppercase;
  }
  h1 {
    font-size: 1.2em;
  }
  h2 {
    font-size: 0.7em;
  }
  .noSubheading {
    margin-bottom: 0.4em;
  }
}
</style>